/**Menghilangkan slash tiket contoh /tiket/angka_namafile
 *
 * contohnya
 * /media/tiket/202320208979_Foto
 * jadi
 * Foto
 */
export function removeTicketPrefix(stringWithPrefix) {
  const removePrefixMedia = stringWithPrefix.replace(/^\/media\/tiket\//, "");
  const clearFileName = removePrefixMedia.replace(/^\d+_/, "");
  const clearfile = clearFileName.replace(/^\d+_/, "");
  const clear = clearfile.replace(/^\d+_/, "");
  return clear;
}
